// extracted by mini-css-extract-plugin
module.exports = {"root":"ToolLogo_root__2mC1H"};